import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickerDay } from '@mui/x-date-pickers/PickerDay';
import { Paper, Box, Typography, IconButton } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TodayIcon from '@mui/icons-material/Today'; // ✅ import the icon
import dayjs from 'dayjs';
import { getAppointmentsCalendar } from '../../../api/appointmentService';
import DateAppointmentsView from '../modals/DateAppointmentsView';

export default function AppointmentsCalendar() {
  const [appointmentDates, setAppointmentDates] = React.useState(new Set());
  const [selectedDate, setSelectedDate] = React.useState(dayjs());
  const [viewOpen, setViewOpen] = React.useState(false);

  React.useEffect(() => {
    async function fetchAppointments() {
      try {
        const appointments = await getAppointmentsCalendar();
        const datesSet = new Set(appointments.map(a => a.date));
        setAppointmentDates(datesSet);
      } catch (err) {
        console.error("Failed to fetch appointments", err);
      }
    }
    fetchAppointments();
  }, []);

  const handleDateClick = (newDate, selectionState) => {
    if (selectionState === "finish") {
      setSelectedDate(newDate); // update calendar state
      setViewOpen(true);
    }
  };

  function AppointmentDay(props) {
    const { day, outsideCurrentMonth, selected, ...other } = props;
    const formatted = day.format("YYYY-MM-DD");
    const isAppointment = appointmentDates.has(formatted);

    return (
      <Box sx={{ position: "relative" }}>
        <PickerDay
          day={day}
          outsideCurrentMonth={outsideCurrentMonth}
          selected={selected}
          {...other}
          sx={{
            ...(selected && {
              backgroundColor: "lightgray !important",
          
              color: "black !important",
              "&:hover": {
                backgroundColor: "lightgray !important"
              }
            })
          }}
        />
        {isAppointment && !outsideCurrentMonth && (
          <AccessTimeIcon
            sx={{
              position: "absolute",
              bottom: 2,
              right: 2,
              fontSize: "0.9rem",
              color: "secondary.main",
              pointerEvents: "none" // ✅ don’t block clicks
            }}
          />
        )}
      </Box>
    );
  }

  return (
    <>
    <Paper elevation={3}>
      <Box sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6">Clinic Calendar</Typography>
        <IconButton
          color="primary"
          size="small"
          onClick={() => setSelectedDate(dayjs())}
        >
          <Typography variant="caption">TODAY</Typography> <TodayIcon />
        </IconButton>
      </Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateCalendar
          value={selectedDate}
          onChange={handleDateClick} // ✅ hook into clicks
          slots={{
            day: AppointmentDay
          }}
        />
      </LocalizationProvider>
    </Paper>
    <DateAppointmentsView 
      date={selectedDate.format("YYYY-MM-DD")}
      open={viewOpen}
      onClose={() => setViewOpen(false)}
    />
    </>
  );
}

